import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Segment
} from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class DepartamentosView extends Component {

  constructor (props) {
    super(props);

    this.DepartamentoService = this.props.feathers.service('/api/departamentos');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(departamento) => ({
            id: departamento.id,
            header: `${departamento.nombre}`
          })}
          service={this.DepartamentoService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8]
            ],
            service: this.DepartamentoService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    DepartamentosView.mapStateToProps,
    DepartamentosView.mapDispatchToProps
  )(DepartamentosView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/DepartamentosView.js